export const RolesEnum = Object.freeze({
    SUPERADMIN: "SUPERADMIN",
    ADMINISTRADOR: "ADMINISTRADOR",
    GESTOR: "GESTOR",
    USUARIO: "USUARIO"
});